import SetChildrenInteractive from '../utils/setchildreninteractive/SetChildrenInteractive.js';

var SetChildrenInteractiveWrap = function (config) {    
    SetChildrenInteractive(this, config);
    return this;
}

export default SetChildrenInteractiveWrap;